import { useEffect, useRef, useState } from 'react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import { SxProps, Theme, Tooltip, TooltipProps } from '@mui/material';

type TStyles = {
  infoIcon: (theme: Theme) => SxProps<Theme>;
};

const focusTime = 10;

export const styles: TStyles = {
  infoIcon: (theme: Theme) => ({
    color: `${theme.palette.primary.main}70`,
    '&:hover': { color: theme.palette.primary.main },
    cursor: 'pointer',
    pointerEvents: 'auto',
  }),
};

interface IInfoTooltip extends Omit<TooltipProps, 'children'> {
  iconStyles?: (theme: Theme) => SxProps<Theme>;
}

export const InfoTooltip = ({ iconStyles, ...props }: IInfoTooltip) => {
  const [open, setOpen] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleOpen = () => {
    clearTimeout(timerRef.current as unknown as number);
    setOpen(true);
  };

  const handleClose = () => {
    timerRef.current = setTimeout(() => setOpen(false), focusTime);
  };

  useEffect(() => () => clearTimeout(timerRef.current as unknown as number), []);

  return (
    <Tooltip
      {...props}
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      placement={props.placement || 'top'}
      enterTouchDelay={0}
      leaveTouchDelay={focusTime}
    >
      <InfoOutlineIcon
        sx={(theme) => ({
          ...styles.infoIcon(theme),
          ...iconStyles?.(theme),
        })}
      />
    </Tooltip>
  );
};
